import { useTranslation } from 'react-i18next';
import { ErrorModal } from './error_modal.component';
import { useState } from 'react';
import { Input } from 'components/inputs/input.component';
import { BodyConfirmModal } from './body/body_confirm_modal.component';

interface ErrorModalProps {
  title: string;
  isOpen: boolean;
  children?: JSX.Element;
  onClose: () => void;
  onConfirm: ( password: string ) => Promise<boolean>;
}

export function ConfirmPasswordModal( { title, isOpen, children, onClose, onConfirm }: ErrorModalProps ) {
  const { t } = useTranslation();

  const [ password, setPassword ] = useState<string>( '' );

  const onCheckPassword = async () => {
    const isValidPassowrd =  await onConfirm( password );
    if ( isValidPassowrd ) {
      onClose();
    }
  };

  /*------------------------------- Front -------------------------------*/
  return (
    <ErrorModal
      title={ title }
      onClose={ onClose }
      isOpen={ isOpen }
      hasCross={ false }
    >
      <BodyConfirmModal
        confirmText={ t( 'Delete' ) }
        canConfirm={ password == '' }
        onConfirm={ onCheckPassword }
        onCancel={ onClose }
      >
        <div className='flex flex-col w-full h-full p-3 gap-2'>

          { children }

          <div className='mx-5'>
            <Input
              isPassword
              value={ password }
              onChange={ setPassword }
            />
          </div>
        </div>
      </BodyConfirmModal>
    </ErrorModal>
  );
}